module.exports = __webpack_public_path__ + "media/login.165bb8ed.mp4";